import ChevronDown from "@/assets/icons/chevron-down.svg?react";
import Summary from "@/assets/icons/summary.svg?react";

import Insights from "@/assets/icons/insights.svg?react";

import CreditExplorer from "@/assets/icons/credit-explorer.svg?react";

import Downloads from "@/assets/icons/downloads.svg?react";
import DataAPI from "@/assets/icons/data-api.svg?react";

import InfoIcon from "@/assets/icons/info-icon.svg?react";

import GreenChevron from "@/assets/icons/positive-change.svg?react";
import RedChevron from "@/assets/icons/negative-change.svg?react";

import Trash from "@/assets/icons/trash.svg?react";
import Calendar from "@/assets/icons/calendar.svg?react";

import UploadIcon from "@/assets/icons/upload-icon.svg?react";
import HomeIcon from "@/assets/icons/home.svg?react";
import Upload from "@/assets/icons/upload.svg?react";
import ChevronCircle from "@/assets/icons/chevron-circle.svg?react";
import Check from "@/assets/icons/check.svg?react";
import Analytics from "@/assets/icons/analytics.svg?react";
import Download from "@/assets/icons/download.svg?react";
import Edit from "@/assets/icons/edit.svg?react";
import Toggle from "@/assets/icons/toggle.svg?react";
import InsightsNavbar from "@/assets/icons/insightsNavbar.svg?react";
import UploadNavbar from "@/assets/icons/uploadNavbar.svg?react";
import UploadProduct from "@/assets/icons/uploadProduct.svg?react";
import Criteria from "@/assets/icons/criteria.svg?react";
import FilterStyle from "@/assets/icons/FilterStyle.svg?react";
export const ICON_SOURCE_MAP = {
  chevronDown: ChevronDown,

  summary: Summary,
  insights: Insights,
  downloads: Downloads,
  "data-api": DataAPI,
  "credit-explorer": CreditExplorer,

  info: InfoIcon,
  "positive-change": GreenChevron,
  "negative-change": RedChevron,
  trash: Trash,
  calendar: Calendar,
  "upload-icon": UploadIcon,
  home: HomeIcon,
  upload: Upload,
  "chevron-circle": ChevronCircle,
  check: Check,
  analytics: Analytics,
  download: Download,
  edit: Edit,
  toggle: Toggle,
  insightsNavbar: InsightsNavbar,
  uploadNavbar: UploadNavbar,
  uploadProduct: UploadProduct,
  criteria: Criteria,
  filterStyle: FilterStyle,
};

interface IconProps {
  name: keyof typeof ICON_SOURCE_MAP;
  className?: string;
  height?: number;
  width?: number;
  size?: number;
  color?: string;
}

const Icon = ({ name, className, width, height, size }: IconProps) => {
  const RequiredIcon = ICON_SOURCE_MAP[name];
  return (
    <RequiredIcon
      className={className}
      width={size || width || 24}
      height={size || height || 24}
    />
  );
};

export default Icon;
